import { Link } from "react-router-dom";
import { DoorOpen, KeyRound, Wrench, Siren, Shield, Settings, Lock, ArrowRight } from "lucide-react";
import { services } from "../data/services";

const iconMap = {
  DoorOpen: DoorOpen,
  KeyRound: KeyRound,
  Wrench: Wrench,
  Siren: Siren,
  Shield: Shield,
  Settings: Settings,
  Lock: Lock
};

export const Services = () => {
  return (
    <section id="services" className="section-padding bg-white" data-testid="services-section">
      <div className="container-custom">
        {/* Header */}
        <div className="max-w-3xl mb-16">
          <span className="text-yellow-500 font-bold uppercase tracking-wider text-sm mb-4 block">
            Nos services
          </span>
          <h2 className="text-4xl md:text-5xl font-bold uppercase tracking-tight text-zinc-900 mb-6 font-heading">
            Services de serrurerie
            <span className="block text-yellow-500">à Lieusaint</span>
          </h2>
          <p className="text-lg text-zinc-600">
            Notre équipe de serruriers professionnels intervient rapidement pour tous vos besoins 
            en serrurerie : urgences, installations et réparations.
          </p>
        </div>

        {/* Services Grid - Bento Style */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon] || Lock;
            const isLarge = index === 0 || index === 3;
            
            return (
              <Link
                key={service.id}
                to={`/service/${service.slug}`}
                className={`group relative bg-zinc-50 border border-zinc-200 rounded-sm overflow-hidden transition-all duration-300 hover:border-zinc-900 hover:shadow-xl hover:-translate-y-1 ${
                  isLarge ? 'md:col-span-2 lg:col-span-1' : ''
                }`}
                data-testid={`service-card-${service.slug}`}
              >
                {/* Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.imageAlt}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-zinc-900/80 to-transparent" />
                  
                  {/* Icon */}
                  <div className="absolute bottom-4 left-4 w-12 h-12 bg-yellow-400 rounded-sm flex items-center justify-center">
                    <IconComponent className="w-6 h-6 text-black" />
                  </div>
                </div>

                {/* Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold uppercase tracking-tight text-zinc-900 mb-2 font-heading group-hover:text-yellow-500 transition-colors">
                    {service.name}
                  </h3>
                  <p className="text-zinc-600 text-sm mb-4">
                    {service.shortDescription}
                  </p>
                  <div className="flex items-center text-yellow-500 font-medium text-sm uppercase tracking-wide">
                    En savoir plus 
                    <ArrowRight className="w-4 h-4 ml-2 transition-transform group-hover:translate-x-2" />
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
